import React from "react";
import { connect } from 'react-redux';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import ReactPlayer from 'react-player'
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from "../../../../../../util/IntlMessages";
import noVideo from "../../../../../../assets/images/images/no-video.png"
import iconVerticalBat from "../../../../../../assets/images/icons/icon-vertical-bat.svg";
import iconHorizontalBat from "../../../../../../assets/images/icons/icon-horizontal-bat.svg";
import iconOffSide from "../../../../../../assets/images/icons/icon-off-side.svg";
import iconOnSide from "../../../../../../assets/images/icons/icon-on-side.svg";
import iconStraight from "../../../../../../assets/images/icons/icon-straight.svg";
import iconAttackingShot from "../../../../../../assets/images/icons/icon-attacking-shot.svg";
import iconPowerfulShot from "../../../../../../assets/images/icons/icon-powerful-shot.svg";
import iconDeffensiveShot from "../../../../../../assets/images/icons/icon-defensive-shot.svg";
import {
    getSwingVideoUserSas
} from '../../../../../../actions/MediaAction';

class Swing extends React.Component {
    constructor() {
        super()
        this.state = {
            swingNum: 1,
            swingType: '',
            swingTypeIcon: '',
            shotDirection: '',
            shotDirectionIcon: '',
            shotType: '',
            shotTypeIcon: '',
            maxBatSpeed: 0,
            impactSpeed: 0,
            power: 0,
            efficiency: 0,
            backliftAngle: 0,
            downswingAngle: 0,
            followthroughAngle: 0,
            backliftDirectionAngle: 0,
            batFaceAngle: 0,
            timeToImpact: 0,
            videoUrl: "",
            displayNoVideo: 'none',
            displayVideoPlayer: 'block'
        }

    }
    componentDidMount() {
        if (this.props.swingList.length > 0 && this.props.swingListLoader === false && this.props.sessionData != null && this.props.sessionData.id === this.props.selectedSession.sessionId) {
            if (this.props.selectedSession.sessionMode !== "manual-video-recording") {
                this.fetchSelectedSwing(this.props.swingList[this.props.swingNum - 1])
                this.setState({
                    swingNum: this.props.swingNum
                })
            } else {
                this.setState({
                    swingNum: this.props.swingNum + 1
                })
            }
            this.swingVideoSas()
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.sessionData != null && this.props.sessionData.id === this.props.selectedSession.sessionId && this.props.swingList.length > 0 && ((prevProps.swingListLoader === true && this.props.swingListLoader === false) || prevProps.swingNum !== this.props.swingNum)) {
            if (this.props.selectedSession.sessionMode !== "manual-video-recording") {
                this.fetchSelectedSwing(this.props.swingList[this.props.swingNum - 1])
                this.setState({
                    swingNum: this.props.swingNum
                })
            } else {
                this.setState({
                    swingNum: this.props.swingNum + 1
                })
            }
            this.swingVideoSas()
            this.setState({
                displayNoVideo: "none",
                displayVideoPlayer: "block"
            })
        }
        if ((prevProps.swingVideoUserSasLoader === true && this.props.swingVideoUserSasLoader === false) || prevProps.swingNum !== this.props.swingNum) {
            this.swingVideoSas()
        }
    }

    swingVideoSas() {
        if (this.props.swingVideoUserSas !== null && this.props.swingVideoUserSas.hasOwnProperty('containerUrl') && this.props.swingVideoUserSas.hasOwnProperty('sas') && this.props.swingVideoUserSas.hasOwnProperty('sasExpiry') && this.props.swingVideoUserSas.hasOwnProperty('playerUid')) {
            if (new Date().getTime() >= this.props.swingVideoUserSas.sasExpiry) {
                this.callGetSwingVideoUserSas()
            } else {
                if (this.props.playerInView.uid !== this.props.swingVideoUserSas.playerUid) {
                    this.callGetSwingVideoUserSas()
                }
            }
        } else {
            this.callGetSwingVideoUserSas()
        }
    }

    callGetSwingVideoUserSas() {
        const sessionToken = this.props.authUser.sessionToken;
        const playerUid = this.props.playerInView.uid;
        const payload = {
            'sessionToken': sessionToken,
            'playerUid': playerUid
        }
        this.props.getSwingVideoUserSas(payload);
    }

    fetchSelectedSwing(swingObj) {
        if (!swingObj) {
            console.log('swing not found')
            return
        }
        switch (swingObj.swingType) {
            case 3:
            case 7:
            case 13:
            case 5:
            case -1:
            case 21:
            case 33:
                this.setState({
                    shotDirection: "Off Side",
                    shotDirectionIcon: iconOffSide
                })
                break;
            case 11:
            case 9:
            case 10:
            case 8:
            case -3:
            case 23:
                this.setState({
                    shotDirection: "On Side",
                    shotDirectionIcon: iconOnSide
                })
                break;
            case 1:
            case -2:
            case 22:
                this.setState({
                    shotDirection: "Straight",
                    shotDirectionIcon: iconStraight
                })
                break;
            default:

        }

        if (swingObj.verticalHorizontalShot === 1) {
            if ((Math.round(swingObj.maxSpeed) <= 30) && (swingObj.swingType === 1 || swingObj.swingType === 3 || swingObj.swingType === 7)) {
                this.setState({
                    shotType: "Deffensive Shot",
                    shotTypeIcon: iconDeffensiveShot
                })
            }
            else if (((Math.round(swingObj.maxSpeed) > 30) && (Math.round(swingObj.maxSpeed) < 60)) && (swingObj.swingType === 1 || swingObj.swingType === 3 || swingObj.swingType === 7)) {
                this.setState({
                    shotType: "Attacking Shot",
                    shotTypeIcon: iconAttackingShot
                })
            }
            else if ((Math.round(swingObj.maxSpeed) < 60) && (swingObj.swingType === 11 || swingObj.swingType === 8)) {
                this.setState({
                    shotType: "Attacking Shot",
                    shotTypeIcon: iconAttackingShot
                })
            }
            else {
                this.setState({
                    shotType: "Powerful Shot",
                    shotTypeIcon: iconPowerfulShot
                })
            }
        } else {
            if (Math.round(swingObj.maxSpeed) < 60) {
                this.setState({
                    shotType: "Attacking Shot",
                    shotTypeIcon: iconAttackingShot
                })
            }
            else {
                this.setState({
                    shotType: "Powerful Shot",
                    shotTypeIcon: iconPowerfulShot
                })
            }
        }

        this.setState({
            swingType: (swingObj.verticalHorizontalShot === 1) ? "Vertical Swing" : "Horizontal Swing",
            swingTypeIcon: (swingObj.verticalHorizontalShot === 1) ? iconVerticalBat : iconHorizontalBat,
            maxBatSpeed: Math.round(swingObj.maxSpeed),
            impactSpeed: Math.round(swingObj.impactSpeed),
            power: Math.round(swingObj.powerFactor),
            efficiency: Math.round(swingObj.efficiency),
            backliftAngle: Math.round(swingObj.backliftAngle),
            downswingAngle: Math.round(swingObj.downswingAngle),
            followthroughAngle: Math.round(swingObj.followthroughAngle),
            backliftDirectionAngle: Math.round(swingObj.backliftDirection),
            batFaceAngle: Math.round(swingObj.batFace),
            timeToImpact: Math.round(swingObj.timeToImpact)
        })
    }
    renderVideo() {
        try {
            if (this.props.swingVideoUserSasLoader !== true) {
                const urlVideo = this.props.swingVideoUserSas.containerUrl + "/" + Math.floor(this.props.sessionData.startDateTs / 1000) + "/" + this.props.swingNum + ".mp4?" + this.props.swingVideoUserSas.sas;
                if ((this.props.sessionData.sessionMode === 'live-video' || this.props.selectedSession.sessionMode === 'manual-video-recording') && ReactPlayer.canPlay(urlVideo) && this.props.sessionData != null && this.props.sessionData.id === this.props.selectedSession.sessionId) {
                    return (
                        <ReactPlayer
                            // playbackRate={.0625}
                            onSeek={(seconds) => {
                                // console.log("onSeek : " + seconds)
                            }}
                            className='react-player'
                            url={urlVideo}
                            width='100%'
                            height='500px'
                            controls={true}
                            config={{
                                file: {
                                    attributes: {
                                        controlsList: 'nodownload'
                                    }
                                }
                            }}
                            onError={(e) => {
                                this.setState({
                                    displayNoVideo: "block",
                                    displayVideoPlayer: "none"
                                })
                                // this.onVideoError(e)
                            }}
                        />
                    )
                } else {
                    return (
                        <div className="align-middle" style={{ marginTop: '-50px' }}>
                            <img src={noVideo} alt='' />
                            <div className="pt-3 text-30">Video not taken for this swing!</div>
                        </div>
                    )
                }
            }
        } catch (error) {
            // console.log("Error : " + error)
        }
    }

    render() {
        return (
            <div className="module-box-content" style={{ margin: '10px 10px 10px 10px' }}>
                <div>
                    <div style={{ padding: '20px 20px 20px 20px' }} className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center ">
                        <h2 className="title mb-3 mb-sm-0">{<IntlMessages id="mySession.swing.swingStats" />} - {this.props.swingNum}</h2>
                    </div>
                </div>
                <div className="row justify-content-md-center justify-content-sm-center">
                    {this.props.selectedSession.sessionMode === "manual-video-recording" ? '' : (
                        <div className="col-lg-8 col-md-12 col-sm-12 col-12">
                            <div className="row">
                                <div className="col-lg-8 col-md-8 col-sm-12">
                                    <div className="card jr-card-intra shadow text-center">
                                        <div className="card-header px-3 py-2 align-items-center">
                                            <h4 className="mb-0"><IntlMessages id="mySession.swing.swingDetails" /></h4>
                                        </div>
                                        <div className="stack-order py-4 px-2 component-height-swing">
                                            <div className="row vertically-center">
                                                <div className="col-lg-6 col-sm-6 col-6">
                                                    {this.props.swingListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionId !== this.props.sessionData.id || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                        <Skeleton animation="wave" variant="rect" style={{ height: 120 }} />
                                                    ) : (
                                                            <div>
                                                                <img src={this.state.swingTypeIcon} alt="" />
                                                                <div className="pt-3"> {this.state.swingType}</div>
                                                            </div>
                                                        )}
                                                </div>
                                                <div className="col-lg-6 col-sm-6 col-6">
                                                    {this.props.swingListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionId !== this.props.sessionData.id || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                        <Skeleton animation="wave" variant="rect" style={{ height: 120 }} />
                                                    ) : (
                                                            <div>
                                                                <img src={this.state.shotTypeIcon} alt="" />
                                                                <div className="pt-3"> {this.state.shotType}</div>
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6">
                                    <div className="card jr-card-intra shadow text-center">
                                        <div className="card-header px-3 py-2 align-items-center">
                                            <h4 className="mb-0"><IntlMessages id="sidebar.maxBatSpeed" /></h4>
                                        </div>
                                        <div className="stack-order px-2 component-height-swing vertically-center">
                                            {this.props.swingListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionId !== this.props.sessionData.id || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="circular-progress-margin" style={{ height: 110, width: '100%' }} />
                                            ) : (
                                                    <div className="circular-progress-margin">
                                                        <CircularProgressbarWithChildren value={this.state.maxBatSpeed} maxValue={79} styles={buildStyles({
                                                            pathTransitionDuration: 0.5,
                                                            pathColor: '#FFCC00',
                                                            textColor: '#f88',
                                                            trailColor: '#fceeb6',
                                                            backgroundColor: '#3e98c7',
                                                        })}>
                                                            <div style={{ fontSize: '30px' }}>
                                                                <span>{this.state.maxBatSpeed}</span>
                                                            </div>
                                                            <div style={{ fontSize: '14px', lineHeight: 0.5 }}>Km/h</div>
                                                        </CircularProgressbarWithChildren>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6">
                                    <div className="card jr-card-intra shadow text-center">
                                        <div className="card-header px-3 py-2 align-items-center">
                                            <h4 className="mb-0"><IntlMessages id="mySession.swing.batSpeedAtImpact" /></h4>
                                        </div>
                                        <div className="stack-order px-2 component-height-swing vertically-center">
                                            {this.props.swingListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionId !== this.props.sessionData.id || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="circular-progress-margin" style={{ height: 110, width: '100%' }} />
                                            ) : (
                                                    <div className="circular-progress-margin">
                                                        <CircularProgressbarWithChildren value={this.state.impactSpeed} maxValue={79} styles={buildStyles({
                                                            pathTransitionDuration: 0.5,
                                                            pathColor: '#FFCC00',
                                                            textColor: '#f88',
                                                            trailColor: '#fceeb6',
                                                            backgroundColor: '#3e98c7',
                                                        })}>
                                                            <div style={{ fontSize: '30px' }}>
                                                                <span>{this.state.impactSpeed}</span>
                                                            </div>
                                                            <div style={{ fontSize: '14px', lineHeight: 0.5 }}>Km/h</div>
                                                        </CircularProgressbarWithChildren>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6">
                                    <div className="card jr-card-intra shadow text-center">
                                        <div className="card-header px-3 py-2 align-items-center">
                                            <h4 className="mb-0"><IntlMessages id="mySession.swing.power" /></h4>
                                        </div>
                                        <div className="stack-order px-2 component-height-swing vertically-center">
                                            {this.props.swingListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionId !== this.props.sessionData.id || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="circular-progress-margin" style={{ height: 110, width: '100%' }} />
                                            ) : (
                                                    <div className="circular-progress-margin">
                                                        <CircularProgressbarWithChildren value={this.state.power} maxValue={2400} styles={buildStyles({
                                                            pathTransitionDuration: 0.5,
                                                            pathColor: '#FFCC00',
                                                            textColor: '#f88',
                                                            trailColor: '#fceeb6',
                                                            backgroundColor: '#3e98c7',
                                                        })}>
                                                            <div style={{ fontSize: '30px' }}>
                                                                <span>{this.state.power}</span>
                                                            </div>
                                                        </CircularProgressbarWithChildren>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6">
                                    <div className="card jr-card-intra shadow text-center">
                                        <div className="card-header px-3 py-2 align-items-center">
                                            <h4 className="mb-0"><IntlMessages id="mySession.swing.efficiency" /></h4>
                                        </div>
                                        <div className="stack-order px-2 component-height-swing vertically-center">
                                            {this.props.swingListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionId !== this.props.sessionData.id || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="circular-progress-margin" style={{ height: 110, width: '100%' }} />
                                            ) : (
                                                    <div className="circular-progress-margin">
                                                        <CircularProgressbarWithChildren value={this.state.efficiency} styles={buildStyles({
                                                            pathTransitionDuration: 0.5,
                                                            pathColor: '#FFCC00',
                                                            textColor: '#f88',
                                                            trailColor: '#fceeb6',
                                                            backgroundColor: '#3e98c7',
                                                        })}>
                                                            <div style={{ fontSize: '30px' }}>
                                                                <span>{this.state.efficiency}%</span>
                                                            </div>
                                                        </CircularProgressbarWithChildren>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6">
                                    <div className="card jr-card-intra shadow text-center">
                                        <div className="card-header px-3 py-2 align-items-center">
                                            <h4 className="mb-0"><IntlMessages id="mySession.insight.backliftAngle" /></h4>
                                        </div>
                                        <div className="stack-order px-2 component-height-swing vertically-center">
                                            {this.props.swingListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionId !== this.props.sessionData.id || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="circular-progress-margin" style={{ height: 110, width: '100%' }} />
                                            ) : (
                                                    <div className="circular-progress-margin">
                                                        <CircularProgressbarWithChildren value={this.state.backliftAngle} maxValue={360} styles={buildStyles({
                                                            pathTransitionDuration: 0.5,
                                                            pathColor: '#FFCC00',
                                                            textColor: '#f88',
                                                            trailColor: '#fceeb6',
                                                            backgroundColor: '#3e98c7',
                                                            rotation: 0.5
                                                        })}>
                                                            <div style={{ fontSize: '30px' }}>
                                                                <span>{this.state.backliftAngle}</span>
                                                            </div>
                                                        </CircularProgressbarWithChildren>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6">
                                    <div className="card jr-card-intra shadow text-center">
                                        <div className="card-header px-3 py-2 align-items-center">
                                            <h4 className="mb-0"><IntlMessages id="mySession.swing.downswingAngle" /></h4>
                                        </div>
                                        <div className="stack-order px-2 component-height-swing vertically-center">
                                            {this.props.swingListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionId !== this.props.sessionData.id || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="circular-progress-margin" style={{ height: 110, width: '100%' }} />
                                            ) : (
                                                    <div className="circular-progress-margin">
                                                        <CircularProgressbarWithChildren value={this.state.downswingAngle} maxValue={360} counterClockwise styles={buildStyles({
                                                            pathTransitionDuration: 0.5,
                                                            pathColor: '#FFCC00',
                                                            textColor: '#f88',
                                                            trailColor: '#fceeb6',
                                                            backgroundColor: '#3e98c7',
                                                            rotation: this.state.backliftAngle / 360 + .5
                                                        })}>
                                                            <div style={{ fontSize: '30px' }}>
                                                                <span>{this.state.downswingAngle}</span>
                                                            </div>
                                                        </CircularProgressbarWithChildren>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6">
                                    <div className="card jr-card-intra shadow text-center">
                                        <div className="card-header px-3 py-2 align-items-center">
                                            <h4 className="mb-0"><IntlMessages id="mySession.swing.followthroughAngle" /></h4>
                                        </div>
                                        <div className="stack-order px-2 component-height-swing vertically-center">
                                            {this.props.swingListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionId !== this.props.sessionData.id || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="circular-progress-margin" style={{ height: 110, width: '100%' }} />
                                            ) : (
                                                    <div className="circular-progress-margin">
                                                        <CircularProgressbarWithChildren value={this.state.followthroughAngle} maxValue={360} counterClockwise styles={buildStyles({
                                                            pathTransitionDuration: 0.5,
                                                            pathColor: '#FFCC00',
                                                            textColor: '#f88',
                                                            trailColor: '#fceeb6',
                                                            backgroundColor: '#3e98c7',
                                                            rotation: this.state.backliftAngle / 360 + .5 - this.state.downswingAngle / 360
                                                        })}>
                                                            <div style={{ fontSize: '30px' }}>
                                                                <span>{this.state.followthroughAngle}</span>
                                                            </div>
                                                        </CircularProgressbarWithChildren>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-4 col-sm-6">
                                    <div className="card jr-card-intra shadow text-center">
                                        <div className="card-header px-3 py-2 align-items-center">
                                            <h4 className="mb-0"><IntlMessages id="mySession.insight.backliftDirectionAngle" /></h4>
                                        </div>
                                        <div className="stack-order px-2 component-height-swing vertically-center">
                                            {this.props.swingListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionId !== this.props.sessionData.id || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="circular-progress-margin" style={{ height: 110, width: '100%' }} />
                                            ) : (
                                                    <div className="circular-progress-margin">
                                                        {this.state.backliftDirectionAngle >= 0 ? (
                                                            <CircularProgressbarWithChildren value={this.state.backliftDirectionAngle} maxValue={360} styles={buildStyles({
                                                                pathTransitionDuration: 0.5,
                                                                pathColor: '#FFCC00',
                                                                textColor: '#f88',
                                                                trailColor: '#fceeb6',
                                                                backgroundColor: '#3e98c7',
                                                            })}>
                                                                <div style={{ fontSize: '30px' }}>
                                                                    <span>{this.state.backliftDirectionAngle}</span>
                                                                </div>
                                                            </CircularProgressbarWithChildren>
                                                        ) : (
                                                                <CircularProgressbarWithChildren value={Math.abs(this.state.backliftDirectionAngle)} counterClockwise maxValue={360} styles={buildStyles({
                                                                    pathTransitionDuration: 0.5,
                                                                    pathColor: '#FFCC00',
                                                                    textColor: '#f88',
                                                                    trailColor: '#fceeb6',
                                                                    backgroundColor: '#3e98c7',
                                                                })}>
                                                                    <div style={{ fontSize: '30px' }}>
                                                                        <span>{this.state.backliftDirectionAngle}</span>
                                                                    </div>
                                                                </CircularProgressbarWithChildren>
                                                            )}
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6">
                                    <div className="card jr-card-intra shadow text-center">
                                        <div className="card-header px-3 py-2 align-items-center">
                                            <h4 className="mb-0"><IntlMessages id="mySession.insight.batfaceAngle" /></h4>
                                        </div>
                                        <div className="stack-order px-2 component-height-swing vertically-center">
                                            {this.props.swingListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionId !== this.props.sessionData.id || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="circular-progress-margin" style={{ height: 110, width: '100%' }} />
                                            ) : (
                                                    <div className="circular-progress-margin">
                                                        {this.state.batFaceAngle >= 0 ? (
                                                            <CircularProgressbarWithChildren value={this.state.batFaceAngle} maxValue={360} styles={buildStyles({
                                                                pathTransitionDuration: 0.5,
                                                                pathColor: '#FFCC00',
                                                                textColor: '#f88',
                                                                trailColor: '#fceeb6',
                                                                backgroundColor: '#3e98c7',
                                                            })}>
                                                                <div style={{ fontSize: '30px' }}>
                                                                    <span>{this.state.batFaceAngle}</span>
                                                                </div>
                                                            </CircularProgressbarWithChildren>
                                                        ) : (
                                                                <CircularProgressbarWithChildren value={Math.abs(this.state.batFaceAngle)} counterClockwise maxValue={360} styles={buildStyles({
                                                                    pathTransitionDuration: 0.5,
                                                                    pathColor: '#FFCC00',
                                                                    textColor: '#f88',
                                                                    trailColor: '#fceeb6',
                                                                    backgroundColor: '#3e98c7',
                                                                })}>
                                                                    <div style={{ fontSize: '30px' }}>
                                                                        <span>{this.state.batFaceAngle}</span>
                                                                    </div>
                                                                </CircularProgressbarWithChildren>
                                                            )}
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6">
                                    <div className="card jr-card-intra shadow text-center">
                                        <div className="card-header px-3 py-2 align-items-center">
                                            <h4 className="mb-0"><IntlMessages id="mySession.swing.timeToImpact" /></h4>
                                        </div>
                                        <div className="stack-order px-2 component-height-swing vertically-center">
                                            {this.props.swingListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionId !== this.props.sessionData.id || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="circular-progress-margin" style={{ height: 110, width: '100%' }} />
                                            ) : (
                                                    <div className="circular-progress-margin">
                                                        <CircularProgressbarWithChildren value={this.state.timeToImpact} styles={buildStyles({
                                                            pathTransitionDuration: 0.5,
                                                            pathColor: '#FFCC00',
                                                            textColor: '#f88',
                                                            trailColor: '#fceeb6',
                                                            backgroundColor: '#3e98c7',
                                                        })}>
                                                            <div style={{ fontSize: '30px' }}>
                                                                <span>{this.state.timeToImpact}</span>
                                                            </div>
                                                            <div style={{ fontSize: '14px', lineHeight: 0.5 }}>ms</div>
                                                        </CircularProgressbarWithChildren>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="col-lg-4 col-md-6 col-sm-8 col-12" style={{ paddingLeft: '5px' }}>
                        <div className="card jr-card-intra shadow text-center">
                            <div className="card-header px-3 py-2 align-items-center">
                                <h4 className="mb-0"><IntlMessages id="mySession.swing.swingVideo" /></h4>
                            </div>
                            <div className="stack-order px-2 vertically-center" style={{ minHeight: '500px' }}>
                                {this.props.swingVideoUserSasLoader || this.props.swingVideoUserSas === null || this.props.playerInView === null || this.props.playerInView.uid !== this.props.swingVideoUserSas.playerUid || this.props.sessionData === null || this.props.selectedSession.sessionId !== this.props.sessionData.id || this.props.playerUid !== this.props.playerInView.uid ? (
                                    <Skeleton animation="wave" variant="rect" className="loader-view w-100" style={{ height: 'calc(100vh - 120px)' }} />
                                ) : (
                                        <div className='player-wrapper' style={{ margin: 'auto' }}>
                                            <div style={{ display: this.state.displayVideoPlayer }}>{this.renderVideo()}</div>

                                            <div className="align-middle" style={{ marginTop: '-50px', display: this.state.displayNoVideo }}>
                                                <img src={noVideo} alt='' />
                                                <div className="pt-3 text-30">Video not taken for this swing!</div>
                                            </div>
                                        </div>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = ({ swing, media, auth, player, session }) => {
    const { authUser } = auth;
    const { playerInView } = player;
    const { sessionData, sessionDataLoader } = session;
    const { swingList, swingListLoader, swingListError, sessionId, playerUid } = swing;
    const { swingVideoUserSas, swingVideoUserSasLoader, swingVideoUserSasError } = media;
    return { authUser, playerInView, sessionData, sessionDataLoader, swingList, swingListLoader, swingListError, sessionId, playerUid, swingVideoUserSas, swingVideoUserSasLoader, swingVideoUserSasError }
};

export default connect(mapStateToProps, {
    getSwingVideoUserSas
})(Swing);